<template>
  <div class="card" style="width: 1200px; margin: 0 auto">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px;position: relative;right:150px">

      <el-breadcrumb-item :to="{ path: '/' }"> <i class="el-icon-location" style="padding-right: 5px" ></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/other/'+article.moduleId }">{{ article.moduleName }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ article.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <h2 style="text-align: center;font-weight: bold;margin-top: 20px;margin-bottom: 20px">{{article.title}}</h2>
<!--    <el-tag size="small">{{ article.moduleName }}</el-tag>-->
   <span style="color: gray"> 日期: {{article.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;来源: {{article.source}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="article.author != null">作者: {{article.author}}</span></span>
    <div style="width: 100%;height:3px;border: 4px solid rgba(90,89,89,0.24);margin-bottom: 10px;margin-top: 10px"></div>

    <p class="content" v-html="article.content"/>
  </div>
</template>

<script>
import {getMessage} from "../api";

export default {
  name: 'articles',
  data() {
    return {
      article: {
        articleName:null,
        createTime:null,
        articleContent:null,
      },
    }
  },
  updated() { //页面加载完毕事件
    window.scroll(0, 0);
  },
  created() {
    this.getMarquee();
  },
  mounted() {

  },
  methods: {
    getMarquee() {
      getMessage(this.$route.params.id).then(res => {

        this.article=res.data.data
        this.article.createTime=res.data.data.createTime.split(' ')[0];
      })
    },

  }
}
</script>

<style scoped>
.card{
  width: 80%;
  margin: auto;
}

</style>
